// import { useSearchParams } from "react-router-dom";
// import dayjs from "dayjs";

// export const useCalendarState = () => {
//   const [searchParams, setSearchParams] = useSearchParams();

//   const endParam = searchParams.get("endDate");
//   const date = endParam ? dayjs(endParam).toDate() : new Date();
//   const view = "month";

//   const getRange = (d) => ({
//     startDate: dayjs().startOf("year").format("YYYY-MM-DD"),
//     endDate: dayjs(d).endOf("month").format("YYYY-MM-DD"),
//   });

//   const range = getRange(date);

//   const update = (newDate) => {
//     const params = new URLSearchParams();
//     params.set("startDate", dayjs().startOf("year").format("YYYY-MM-DD"));
//     params.set("endDate", dayjs(newDate).endOf("month").format("YYYY-MM-DD"));
//     setSearchParams(params);
//   };

//   const setDate = (newDate) => update(newDate);
//   const setView = () => {};

//   return { date, view, setDate, setView, ...range };
// };

// import { useSearchParams } from "react-router-dom";
// import dayjs from "dayjs";

// export const useCalendarState = () => {
//   const [searchParams, setSearchParams] = useSearchParams();

//   const dateParam = searchParams.get("date");
//   const viewParam = searchParams.get("view");

//   const date = dateParam ? dayjs(dateParam).toDate() : new Date();
//   const view = viewParam || "month";

//   const update = (newDate, newView) => {
//     const params = new URLSearchParams();
//     params.set("date", dayjs(newDate).format("YYYY-MM-DD"));
//     params.set("view", newView);
//     setSearchParams(params);
//   };

//   const setDate = (newDate) => update(newDate, view);
//   const setView = (newView) => update(date, newView);

//   return { date, view, setDate, setView };
// };

import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";

export const useCalendarState = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const dateParam = searchParams.get("date");
  const endParam = searchParams.get("endDate");
  const viewParam = searchParams.get("view");

  const view = viewParam || "month";
  const date = dateParam
    ? dayjs(dateParam).toDate()
    : endParam
      ? dayjs(endParam).toDate()
      : new Date();

  const getRange = (d) => ({
    startDate: dayjs().startOf("year").format("YYYY-MM-DD"),
    endDate: dayjs(d).endOf("month").format("YYYY-MM-DD"),
  });

  const range = getRange(date);

  const update = (newDate, newView) => {
    const params = new URLSearchParams();
    params.set("startDate", dayjs().startOf("year").format("YYYY-MM-DD"));
    params.set("endDate", dayjs(newDate).endOf("month").format("YYYY-MM-DD"));
    params.set("view", newView);
    if (newView !== "month") {
      params.set("date", dayjs(newDate).format("YYYY-MM-DD"));
    } else {
      params.delete("date");
    }

    setSearchParams(params);
  };

  const setDate = (newDate) => update(newDate, view);

  const setView = (newView) => {
    const baseDate = newView === "month" ? date : new Date();
    update(baseDate, newView);
  };

  return { date, view, setDate, setView, ...range };
};
